export const DANCE_DESCRIPTION_EN = 'dance description'
export const DANCE_DESCRIPTION_HB = 'פרטי השיר'
export const DELETE_REQUEST = 'delete'
export const UPLOAD_REQUEST = 'upload'
export const DANCE_STYLES = {
    מעגל: 'circle',
    זוגות: 'couples',
    שורות: 'lines',
    'ילדים-שורות': 'kidsLines',
    'זוגות מתחלפים': 'couplesSwap',
    'זוגות-שורות': 'couplesLines',
    זוגותשורות: 'couplesLines',
    ילדים: 'kids',
    'ילדים ': 'kids',
    'ילדים-מעגל': 'kidsCircle',
    'ילדים-זוגות': 'kidsCouples',
    שלישייה: 'threeWay',
    רביעייה: 'fourway',
}
export const MEDIA_TYPES = {
    video: 'VIDEO',
    song: 'SONG',
}

export const VIDEO_MEDIA_TYPES = ['.mp4', '.mkv', '.mov']
export const AUDIO_MEDIA_TYPES = ['.mp3', '.wav']

const MARKID = 'MARKID'
const ROKDIM = 'ROKDIM'
const RIKUD_ISRAELI = 'RIKUD_ISRAELI'
export const MEDIA_SOURCES = {
    markid: MARKID,
    rokdim: ROKDIM,
    rikudIsraeli: RIKUD_ISRAELI,
}

export const ROKDIM_DANCE_URL = 'https://rokdim.co.il/dance'

export const SUGGESTS_BY_ME = 'suggestsByMe'

export const MEDIA_TAGS = ['dance', 'learn']
export const KEYS_OPTIONS_LABLE = {
    artist: 'hebName',
    creators: 'fullName',
    name: 'name',
}
